import axios from 'axios'

export default {
   // 节点机列表
  getNodeList (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeList', params)
  },
  // 节点机概览用户列表
  showGetNodeList (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeTaskList', params)
  },
  // 节点机概览统计数据
  showNodeData (params) {
    return axios.post('/api/rendering/admin/task/node/getNode', params)
  },
  // 大雁云作业列表
  getBuildEndTaskList (params) {
    return axios.post('/api/rendering/admin/task/rendering/getDayanTaskList', params)
  },
  // 删除任务
  deleteTask(params) {
    return axios.patch('/api/rendering/admin/task/rendering/deleteTask', params)
  },
  // 获取空三任务日志renderLog/debugLog
  getSky3Log(params) {
    return axios.post('/api/rendering/admin/task/rendering/showTriLog', params)
  },
  // 开始按钮
  startTask (params) {
    return axios.post('/api/rendering/admin/task/rendering/startTask', params)
  },
  // 获取重建任务日志renderLog/debugLog
  getRebuildLog(params) {
    return axios.post('/api/rendering/admin/task/rendering/showRebuildLog', params)
  },
  // 获取任务重提记录
  getHistoryRenderInfo(params) {
    return axios.post('/api/rendering/admin/task/rendering/getHistoryRenderInfo', params)
  },
  // 清空黑名单
  cleanBlackList(params) {
    return axios.post('/api/rendering/admin/task/rendering/clearblacknodes', params)
  },
  // 增加约束（多个任务和单个任务都适用）
  addConstraints(params) {
    return axios.post('/api/rendering/admin/task/rendering/addConstraints', params)
  },
  // 删除约束
  deleteConstraints(params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteConstraints', params)
  },
  // 重提按钮
  restartTask(params) {
    return axios.post('/api/rendering/admin/task/rendering/recommitTask', params)
  },
  /**
   * 设置超时停止时间
   * @param {Number} taskOverTime
   * @param {Array} taskIds
   */
  setTaskOverTimeStop({ taskIds, taskOverTime }) {
    return axios.post('/api/rendering/admin/task/rendering/setTaskOverTimeStop', { taskIds, taskOverTime })
  },
  // 恢复作业
  regainTask(params) {
    return axios.post('/api/rendering/admin/task/rendering/regainTask', params)
  },
  // 增加群组
  addCategory(params) {
    return axios.post('/api/rendering/admin/task/rendering/addCategory', params)
  },
  // 删除群组
  deleteCategory(params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteCategory', params)
  },
  // 查询所有群组
  queryCategory (params) {
    return axios.post('/api/rendering/admin/front/user/getTaskGroup', params)
  },
  // 新增管理员标签
  addAdminLabel (params) {
    return axios.post('/api/rendering/admin/base/tag/add', params)
  },
  // 删除管理员标签
  deleteAdminLabel (params) {
    return axios.post('/api/rendering/admin/base/tag/delete', params)
  },
  // 获取管理员标签
  getAdminLabel (params) {
    return axios.get('/api/rendering/admin/base/tag/list', params)
  },
  // 添加任务管理员标签
  addTaskAdminLabel (params) {
    return axios.post('/api/rendering/admin/task/common/addTag', params)
  },
  // 获取约束、群组（单个任务）
  renderingGetSingleStrategyForDataBase (params) {
    return axios.post('/api/rendering/admin/task/rendering/getSingleStrategyForDataBase', params)
  },
  // 帧详情任务
  // 帧详情任务列表
  // 注：showLog接口参数id通过该接口获取
  getTaskFrameRenderList (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskFrameRenderList', params)
  },
  // 获取属性要求约束群组（单个任务）
  rebuildGetSingleStrategyForDataBase (params) {
    return axios.post('/api/rendering/admin/task/analyse/getSingleStrategyForDataBase', params)
  },
  // 增加属性（多个任务和单个任务都适用）
  analyseAddProperties (params) {
    return axios.post('/api/rendering/admin/task/analyse/addProperties', params)
  },
  preAddProperties (params) {
    return axios.post('/api/rendering/admin/task/pre/addProperties', params)
  },
  renderingAddProperties (params) {
    return axios.post('/api/rendering/admin/task/rendering/addProperties', params)
  },
  // 增加要求（多个任务和单个任务都适用）
  analyseAddRequirements (params) {
    return axios.post('/api/rendering/admin/task/analyse/addRequirements', params)
  },
  // 添加要求
  renderingAddRequirements (params) {
    return axios.post('/api/rendering/admin/task/rendering/addRequirements', params)
  },
  // 删除属性
  renderingDeleteProperties (params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteProperties', params)
  },
  // 删除要求
  renderingDeleteRequirements (params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteRequirements', params)
  },
  // 停止按钮
  stopTask (params) {
    return axios.post('/api/rendering/admin/task/rendering/stopTask', params)
  },
  // 修改级别按钮
  updateLevel (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateLevel', params)
  },
  // 修改节点机数量按钮
  updateNodeLimit (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateNodeCount', params)
  },
  // 查询频率调度
  getFrequencyControl (params) {
    return axios.post('/api/rendering/admin/task/rendering/getFrequencyControl', params)
  },
  // 设置频率调度
  setFrequencyControl (params) {
    return axios.post('/api/rendering/admin/task/rendering/setTaskScheduleRate', params)
  },
  // 修改频率调度按钮
  updateFrequency (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateFrequency', params)
  },
  // 查看生产日志
  getProductLog (params) {
    return axios.post('/api/rendering/admin/task/rendering/showLog', params)
  },
  // 导出作业Excel
  exportTaskExcel (params) {
    // eslint-disable-next-line no-undef
    return exportAxios('/api/rendering/admin/task/rendering/exportGetWorkExcel', params)
  },
  // 运行的渲染作业统计
  queryTaskOfPlatformStat (params) {
    return axios.post('/api/rendering/admin/task/rendering/queryTaskOfPlatformStat', params)
  },
  // 单个用户所有金额统计
  queryAmount (params) {
    return axios.post('/api/rendering/admin/task/rendering/queryAmount', params)
  },
  // 更新修改标签
  updateTaskLabel (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateTaskLabel', params)
  },
  // 获取提交失败的错误信息
  getSubmitTaskFailMessage (params) {
    return axios.post('/api/rendering/admin/task/rendering/getSubmitTaskFailMessage', params)
  },
  // 预处理停止
  stopPreTask (params = {
  }) {
    return axios.post('/api/rendering/admin/task/pre/stopPreTask', params)
  },
  // 获取预处理木牛log
  getPreHandleLog (params) {
    return axios.post('/api/rendering/admin/task/pre/showLog', params)
  },
  // 获取预处理log
  getPerMunuLog (params) {
    return axios.post('/api/rendering/admin/task/pre/getRenderMunuLog', params)
  },
  // 重提帧任务
  recommitTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/recommitTaskFrame', params)
  },
  // 停止帧任务
  stopTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/stopTaskFrame', params)
  },
  // 开始帧任务
  startTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/startTaskFrame', params)
  },
  // 查询帧耗时分布图以及帧完成情况
  getFrameCondition (params) {
    return axios.post('/api/rendering/admin/task/rendering/getFrameCondition', params)
  },
  // 查询配置详情
  loadingTaskParameter (params) {
    return axios.post('/api/rendering/admin/task/rendering/loadingTaskParameter', params)
  },
  // 加载帧的缩略图
  loadingTaskThumbnail (params) {
    return axios.post('/api/rendering/admin/task/rendering/loadingTaskThumbnail', params)
  },
  // 查询配置文档名称
  getJsonFileName (params) {
    return axios.post('/api/rendering/admin/task/rendering/getJsonFileName', params)
  },
  // 用户输入输出路径
  getOutOrInputPath (params) {
    return axios.post('/api/rendering/admin/task/rendering/getOutOrInputPath', params)
  },
  // 查询账户信息
  queryAccountInfo (params) {
    return axios.post('/api/rendering/admin/task/rendering/getMainUserIdsByUserIds', params)
  },
   // 运行的作业，内存升级的信息查询
  advanceParameterSetting (params) {
    return axios.post('/api/rendering/admin/task/rendering/advanceParameterSetting', params)
  },
  // 获取任务关联工单
  getJiraIssues (params) {
    return axios.post('/api/rendering/admin/base/getJiraIssues', params)
  },
  // 获取任务帧总数及费用
  getSumFrameConsume (params) {
    return axios.post('/api/rendering/admin/task/rendering/getSumFrameConsume', params)
  },
  // 查询配置文档
  getTaskJson (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskJson', params)
  },
  // 瓦片详情列表统计信息
  getFrameStatisticMessage (params) {
    return axios.post('/api/rendering/admin/task/rendering/taskRenderingConsume', params)
  },
  // 任务记录列表
  getTaskFrameConsumeInfo (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskFrameConsumeInfo', params)
  },
  // 获取大雁云发布列表
  getTaskPublishList (params) {
    return axios.post('/api/rendering/admin/task/rendering/getDayanPublishList', params)
  },
  // 修改备注按钮
  updateRemark(params) {
    return axios.post('/api/rendering/admin/task/rendering/updateRemark', params)
  },
  // 获取生产预览路径(模型)
  getTaskCesium3DTilesUrl(params) {
    return axios.post('/api/rendering/admin/task/rendering/loadTaskCesium3DTilesUrl', params)
  },
  // 获取空三预览路径(点云)
  getTaskPointCloudDataUrl(params) {
    return axios.post('/api/rendering/admin/task/rendering/loadTaskPointCloudDataUrl', params)
  },
}
